import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: ${({ isRecording }) =>
        isRecording ? 'space-evenly' : 'center'};
    align-items: center;
    font-family: Avenir;
    cursor: default;
`
